export default __webpack_public_path__ + "static/baner4-a7cf421bb57cd6de99f5cbeb89d32543.png";